import { UserManager } from "oidc-client-ts";

// const oidcConfig = {
//   authority: "https://lecabit-yvgaz8.us1.zitadel.cloud/", // e.g. https://accounts.google.com or your Auth server
//   client_id: "336531436729371013",
//   redirect_uri: `${window.location.origin}/oidc/callback`,
//   response_type: "code",
//   scope: "openid profile email",
//   post_logout_redirect_uri: `${window.location.origin}/login`,
//   // PKCE is enabled by default
// };

// const oidcConfig = {
//   authority: "https://login.microsoftonline.com/common", // e.g. https://accounts.google.com or your Auth server
//   client_id: "8c002588-dafa-4f15-9a9f-664e58fcf8f6",
//   redirect_uri: `${window.location.origin}/oidc/common/callback`,
//   response_type: "code",
//   scope: "openid profile email",
//   post_logout_redirect_uri: `${window.location.origin}/login`,
//   // PKCE is enabled by default
// };

const oidcConfigs = {
  "Google": {
    authority: "https://accounts.google.com", // e.g. https://accounts.google.com or your Auth server
    client_id: "375155993689-ehug6p01pbnl80qo8dj6edps7p0qino6.apps.googleusercontent.com",
    redirect_uri: `${window.location.origin}/oidc/common/callback`,
    response_type: "id_token token",
    scope: "openid profile email",
    post_logout_redirect_uri: `${window.location.origin}/login`,
    // PKCE is enabled by default
  },
  "Microsoft": {
    // authority: "https://login.microsoftonline.com/common", // e.g. https://accounts.google.com or your Auth server
    // client_id: "8c002588-dafa-4f15-9a9f-664e58fcf8f6",
    // redirect_uri: `${window.location.origin}/oidc/common/callback`,
    // response_type: "code",
    // scope: "openid profile email",
    // post_logout_redirect_uri: `${window.location.origin}/login`,
    // PKCE is enabled by default
    authority: "https://login.microsoftonline.com/common",
    client_id: "8c002588-dafa-4f15-9a9f-664e58fcf8f6",
    redirect_uri: `${window.location.origin}/oidc/common/callback`,
    response_type: "code", // Authorization Code flow
    scope: "openid profile email https://graph.microsoft.com/User.Read",
    post_logout_redirect_uri: `${window.location.origin}/login`,
  }
}

// Write a function to get the right config based on some criteria
// For example, based on a query parameter or some app state
export const getOidcUserManager = (provider) => {
  const oidcConfig = oidcConfigs[provider] || null; // Default to Google if no match
  if (!oidcConfig) {
    throw new Error("No valid OIDC configuration found for the specified provider.");
  }
  
  return new UserManager(oidcConfig);
};

export const userManager = getOidcUserManager("Microsoft");